import React from 'react';
import { PlanOption as PlanOptionType } from './types';
import { Slider } from '@mui/material';
import { FormLabel } from '@mui/material';

interface PlanOptionProps {
  option: PlanOptionType;
  value: number;
  onChange: (value: number) => void;
}

export const PlanOptionSelector: React.FC<PlanOptionProps> = ({ option, value, onChange }) => {
  return (
    <div className="mb-6">
      <FormLabel htmlFor={option.name} sx={{ fontSize: '1.125rem', fontWeight: 'bold', mb: 1 }} className="text-primary">
        {option.name === 'data' ? 'Data' : option.name === 'voice' ? 'Voice' : 'SMS'}
      </FormLabel>
      <Slider
        id={option.name}
        value={value}
        min={option.min}
        max={option.max}
        step={option.step}
        onChange={(_, newValue) => onChange(newValue as number)}
        sx={{ mb: 1 }}
      />
      <div className="flex justify-between text-sm text-primary">
        <span>{value} {option.unit}</span>
        <span>${(value * option.pricePerUnit).toFixed(2)}</span>
      </div>
    </div>
  );
};